import React, { useState } from "react";
import PropTypes from "prop-types";

import { PhotoDownloadType } from "js/graphql";

import { useCurrentUserContext } from "js/contexts/CurrentUserContext";

import { authLinks } from "data/links";

import LoadingSpinner from "core/LoadingSpinner";
import DownloadPhotoButton from "./DownloadPhotoButton";
import DownloadMessage from "core/DownloadMessage";
import AttributionPublic from "core/AttributionPublic";

import Button from "core/Button";
import { StyledPublicDomainDownloadSection } from "./styles";

const PublicDomainDownloadSection = ({ photo }) => {
    const {
        currentUser: { loading: loadingCurrentUser, data }
    } = useCurrentUserContext();

    const [downloaded, setDownloaded] = useState(false);

    if (loadingCurrentUser) return <LoadingSpinner />;

    const loggedIn = !loadingCurrentUser && data && !!data.currentUser;

    const handleButtonClick = e => {
        e.preventDefault();

        if (loggedIn) {
            setDownloaded(true);
        } else {
            redirectToSignupPage();
        }

        function redirectToSignupPage() {
            const next = encodeURIComponent(
                location.pathname + location.search
            );

            /* using window.location.replace instead of
            reach router's navigate fn because we are redirecting
            to a page that is not found in the photos router */
            window.location.replace(`${authLinks.signup.href}?next=${next}`);
        }
    };

    const ctaButton = loggedIn ? (
        <DownloadPhotoButton
            downloadType={PhotoDownloadType.Public}
            photoId={photo.id}
        >
            Download JPG
        </DownloadPhotoButton>
    ) : (
        <Button
            styleType="cta"
            onClick={e => handleButtonClick(e)}
            width="100%"
            darkMode
        >
            Download JPG
        </Button>
    );

    return (
        <StyledPublicDomainDownloadSection>
            <DownloadMessage isPublicDomain={true} photo={photo} />
            <AttributionPublic type="photo" />
            {ctaButton}
        </StyledPublicDomainDownloadSection>
    );
};

PublicDomainDownloadSection.propTypes = {
    photo: PropTypes.object.isRequired
};

export default PublicDomainDownloadSection;
